import styles from '../CoveredInClass/style.postcss';

import React from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';
import { List, Record, Map } from 'immutable';
import {
  connect,
  moment,
  ApiCall,
  PrivilegeChecker,
  Config,
  ConfirmDialog,
  ErrorDialog,
  Grid,
  Checkbox,
  SolidRadio,
  ColourLabel,
  PageCard,
  StudentPicture,
} from 'omni-common-ui';
import PageActivitiesPart from '../CoveredInClass/PageActivitiesPart';
import CoveredInClassCategoryView from '../CoveredInClass/CoveredInClassCategoryView';
import { push } from 'react-router-redux';
import { actions as sessionPlansActions } from 'data/SessionPlans';
import { bindActionCreators } from 'redux';
import { actions as CoveredInClassActions, accessors, CoveredInClass as CoveredInClassModel } from 'data/CoveredInClass';
import { actions as CoveredInClassTemplateActions } from 'data/CoveredInClass/Template';
import { actions as CICCategoryTemplateActions } from 'data/CoveredInClass/CategoryTemplate';
import { actions as HF4HomeworkActions, accessors as hf4HomeworkAccessors } from 'data/HF4Homework';
import { accessors as groupLessonAwardsAccessors } from 'data/GroupLessonAwards';
import InternalNotesPart from '../CoveredInClass/InternalNotesPart';
import { withRouter } from 'react-router';
import { exporter } from 'domain/Exporter';
import Privileges from 'domain/Privileges';
import Languages from 'domain/Languages';
import { actions as Group } from 'containers/Group';
import { actions as UiState } from 'data/UiState';
import { getUnitNumberById, getUnitList } from 'data/Units/accessors';
import UnsavedChangesTrackingPageComponent from 'components/UnsavedChangesTrackingPageComponent';
import UnsavedChangesWarning from 'components/UnsavedChangesWarning';
import NoContentMessage from 'components/NoContentMessage';
import LanguageRadio from 'components/LanguageRadio';
import AddFreeTextDialog from '../CoveredInClass/AddFreeTextDialog';

import { Modes } from './routes';
import { getMembersByGroup, fetchGroupMembersIfNeeded } from 'data/GroupMembers/actions';
import { findPointByUUID, findBadgeByUUID } from 'assets/utils/extAsset';
import { fetchGroupLessonAwardsIfNeeded } from 'data/GroupLessonAwards/actions';

const EXPORT = 'EXPORT';
const CANCEL = 'CANCEL';
const EXPORT_OPTION_ONE = 'one';
const EXPORT_OPTION_UNIT = 'unit';
const EXPORT_OPTION_ALL = 'all';
const TITLE_EXPORT_OPTIONS = 'Export Options';
const NAME_EXPORT_OPTIONS = 'export';
const DESCRIPTION_EXPORT_OPTIONS = 'Export Covered in Class for…';

export class CoveredInClass extends UnsavedChangesTrackingPageComponent {
  constructor(props) {
    super(props);

    this._onChecked = this._onChecked.bind(this);
  }

  componentWillMount() {
    this.state = {
      allowRouteLeave: false,
      isChanged: false,
      isExportInProgress: false,
      isExportErrorOccurred: false,
      isNotFoundSessions: false,
      isShowExportOptions: false,
      selectedExportValue: EXPORT_OPTION_ONE,
      showAllPerformance: false,
    };
    this._fetchData(this.props);
    super.componentWillMount();
    this._initChoosedLanguage();
    this._initCICContent();
    this._initCICCategory();
    this.props.fetchGroupMembersIfNeeded(this.props.params.groupId);
  }

  componentWillReceiveProps(props) {
    if (this.props.currentSessionIndex !== props.currentSessionIndex) {
      this.setState({
        allowRouteLeave: false,
        isChanged: false,
      });
    }
    const languageChanged = this.props.cicDisplayLanguage !== props.cicDisplayLanguage;
    if (languageChanged) {
      this._pendingLanguageSwitch = true;
    }
    this._fetchData(props, languageChanged);

    if (this._pendingLanguageSwitch && !languageChanged && !props.isAnyApiCalling &&
        props.hasCICTemplate && props.isNotPublished) {
      this._pendingLanguageSwitch = false;
      this.props.changeCoveredInClassObject(props.coveredInClassTemplate, props.params.sessionPlanId);
    } else if (!this._pendingLanguageSwitch) {
      this._initCICContent();
    }
  }

  _fetchData(props, shouldForceHFv4TemplateFetch = false) {
    this.props.fetchSessionPlansIfNeeded(props.params.groupId);
    if (shouldForceHFv4TemplateFetch) {
      this.props.fetchHFv4CICTemplate(props.params.sessionPlanId, props.cicDisplayLanguage);
    } else {
      this.props.fetchHFv4CICTemplateIfNeeded(props.params.sessionPlanId, props.cicDisplayLanguage);
    }
    this.props.fetchCoveredInClassIfNeeded(props.params.sessionPlanId);
    this.props.fetchHF4HomeworkIfNeeded(props.params.sessionPlanId);
    this.props.fetchGroupLessonAwardsIfNeeded(props.params.sessionPlanId);
  }

  _initCICCategory() {
    const { groupId } = this.props.params;
    this.props.fetchCICCategoriesIfNeeded(groupId);
  }

  _initCICContent() {
    const {
      coveredInClassTemplate,
      coveredInClassContent,
      hasCICTemplate,
      hasCIC,
      isNotPublished,
    } = this.props;
    if (! coveredInClassContent || ! hasCICTemplate || hasCIC || ! isNotPublished) {
      return;
    }
    if (this.props.isAnyApiCalling) {
      return;
    }
    let coveredInClassObject;
    if (this._canCICEdit()) {
      coveredInClassObject = coveredInClassContent;
      coveredInClassObject = coveredInClassObject.map((coveredInClass, key) =>
        coveredInClass.set('cicActivities', coveredInClassTemplate.get(key).cicActivities)
          .set('cicCategories', coveredInClassTemplate.get(key).cicCategories));
    } else if (! this._isNotFutureSession()) {
      coveredInClassObject = coveredInClassTemplate;
    } else {
      coveredInClassObject = coveredInClassContent;
      // coveredInClassObject = coveredInClassObject.map((coveredInClass, key) =>
      //     coveredInClass.update('cicActivities', coveredInClassTemplate.get(key).cicActivities)
      //       .set('cicCategories', coveredInClassTemplate.get(key).cicCategories));
    }
    this.props.changeCoveredInClassObject(coveredInClassObject, this.props.params.sessionPlanId);
  }

  _isChangesPresent() {
    // do not worry about notes - we will auto-save these on leaving
    return !! this.state.isChanged;
  }

  _isInCoveredInClassEditMode(pathname) {
    const { sessionPlanId } = this.props.params;
    return Object.values(Modes).some((mode) =>
      pathname.endsWith(`${sessionPlanId}/covered-in-class/${mode}`));
  }

  routerWillLeave(nextLocation) {
    if (nextLocation && nextLocation.pathname.endsWith(`/${Modes.EXPORT}`)) {
      this._onBeginExport();
      return false;
    } else if (nextLocation && nextLocation.pathname.endsWith(`/${Modes.PUBLISH}`)) {
      this._publishCIC();
      return false;
      // OMO-1254: user navigates away while editing a note; auto-save it
      // TODO: clean up fuzzy detection of whether we're staying on the same page
    } else if (nextLocation && nextLocation.pathname.endsWith(`/${Modes.CLEAR}`)) {
      this._clearCIC();
    } else if (this._willRemainOnCurrentPage(nextLocation)) return;

    this._autoSaveNotes();
    return super.routerWillLeave(nextLocation);
  }

  _autoSaveNotes() {
    if (! this.internalNotesPartComponent) return;
    this.internalNotesPartComponent.autoSaveNotesIfNeeded();
  }

  _willRemainOnCurrentPage(nextLocation) {
    const currentPath = this.props.buildRoute({ mode: '', index: '' });
    return nextLocation && (nextLocation.pathname.indexOf(currentPath) >= 0);
  }

  _pageActivitiesChanged(newPageActivities, unitId, lessonNumber) {
    this.setState({ isChanged: true });
    const { coveredInClassContent, params } = this.props;
    const newCoveredInClassContent = coveredInClassContent.update(`${unitId}-${lessonNumber}`,
      (cic) => cic.set('cicActivities', newPageActivities));
    this.props.changeCoveredInClassObject(newCoveredInClassContent, params.sessionPlanId);
  }

  _categoriesChanged(newCategories, unitId, lessonNumber) {
    this.setState({ isChanged: true });
    const { coveredInClassContent, params } = this.props;

    const newCoveredInClassContent = coveredInClassContent.update(`${unitId}-${lessonNumber}`,
      (cic) => cic.set('cicCategories', newCategories));
    this.props.changeCoveredInClassObject(newCoveredInClassContent, params.sessionPlanId);
  }

  _getModeAndIndex() {
    return { mode: this.props.params.mode, index: this.props.params.index };
  }

  _onChangeMode(modeAndIndex) {
    const { mode, index = '' } = modeAndIndex;
    this._forcePushRoute(this.props.buildRoute({ mode, index }));
  }

  _onBeginExport() {
    this.setState({
      isShowExportOptions: true,
      selectedExportValue: EXPORT_OPTION_ONE,
    });
    this._initChoosedLanguage();
  }

  _onEndExport() {
    this.setState({ isShowExportOptions: false });
  }

  _onBeginGeneralError() {
    this.setState({ isExportErrorOccurred: true });
  }

  _onBeginExportWarning() {
    this.setState({ isNotFoundSessions: true });
  }

  _onEndExportWarningOrError() {
    this.setState({
      isNotFoundSessions: false,
      isExportErrorOccurred: false,
    });
  }

  _renderExportOptionDialog() {
    return <ConfirmDialog isOpen={this.state.isShowExportOptions}
        isLoading={this.state.isExportInProgress}
        title={TITLE_EXPORT_OPTIONS}
        primaryButtonContent={EXPORT}
        secondaryButtonContent={CANCEL}
        onRequestClose={() => {
          this._onEndExport();
        }}
        onPrimaryClick={() => {
          this._handleConfirmExport();
        }}
        onSecondaryClick={() => {
          this._onEndExport();
        }}>
      <div>
        <div>{DESCRIPTION_EXPORT_OPTIONS}</div>
        <div className={styles.CoveredInClass_exportOptions}>
          <div className={styles.CoveredInClass_exportOption}>
            <SolidRadio id="1"
                value={EXPORT_OPTION_ONE}
                name={NAME_EXPORT_OPTIONS}
                isChecked={this.state.selectedExportValue === EXPORT_OPTION_ONE}
                onChange={(value) => this._handleExportChange(value)} />current session
          </div>
          <div className={styles.CoveredInClass_exportOption}>
            <SolidRadio id="2"
                value={EXPORT_OPTION_UNIT}
                name={NAME_EXPORT_OPTIONS}
                isChecked={this.state.selectedExportValue === EXPORT_OPTION_UNIT}
                onChange={(value) => this._handleExportChange(value)} />current unit
          </div>
          <div className={styles.CoveredInClass_exportOption}>
            <SolidRadio id="3"
                value={EXPORT_OPTION_ALL}
                name={NAME_EXPORT_OPTIONS}
                isChecked={this.state.selectedExportValue === EXPORT_OPTION_ALL}
                onChange={(value) => this._handleExportChange(value)} />all taught sessions
          </div>
        </div>
        {this._renderLanguagePicker()}
      </div>
    </ConfirmDialog>;
  }

  _renderLanguagePicker() {
    if (this._isDefaultLanguage()) return;
    return [
      <div className={styles.CoveredInClass_exportOptionsDivider}
          key="CoveredInClass_exportOptionsDivider" />,
      <div className={styles.CoveredInClass_languagePicker}
          key="CoveredInClass_languagePicker">
        <LanguageRadio title="Choose Language:"
            languageCode={this.props.languageCode}
            name="CICLanguagePicker"
            onChecked={this._onChecked}
            choosedLanguageCode={this.state.choosedLanguage} />
      </div>,
    ];
  }

  _initChoosedLanguage() {
    this.setState({ choosedLanguage: this.props.languageCode });
  }

  _isDefaultLanguage() {
    if (! this.props.languageCode) return true;
    return this.props.languageCode === Languages.defaultLanguageCode;
  }

  _onChecked(checkedLanguage) {
    this.setState({ choosedLanguage: checkedLanguage });
  }

  _handleExportChange(value) {
    this.setState({ selectedExportValue: value });
  }

  _handleConfirmExport() {
    const { sessionPlanId, groupId } = this.props.params;
    let sourceUrl = '';
    const languageQueryString =
      `?languageCode=${this.state.choosedLanguage || Languages.defaultLanguageCode}`;
    switch (this.state.selectedExportValue) {
      case EXPORT_OPTION_ONE:
        sourceUrl = `/sessions/${sessionPlanId}/cic-printing${languageQueryString}`;
        this._beginExport(Config.get('apiBase').concat(sourceUrl));
        break;
      case EXPORT_OPTION_UNIT:
        sourceUrl = `/sessions/${sessionPlanId}/unit-sessions/cic-printing${languageQueryString}`;
        this._beginExport(Config.get('apiBase').concat(sourceUrl));
        break;
      case EXPORT_OPTION_ALL:
        sourceUrl = `/groups/${groupId}/sessions/cic-printing${languageQueryString}`;
        this._beginExport(Config.get('apiBase').concat(sourceUrl));
        break;
      default:
        break;
    }
  }

  _handleExportError(error) {
    this.setState({
      isExportInProgress: false,
      isShowExportOptions: false,
    });
    if (error.response.status === 404) {
      this._onBeginExportWarning();
      return;
    }
    this._onBeginGeneralError();
  }

  _beginExport(url) {
    this.setState({
      isExportInProgress: true,
    });
    exporter.get(url,
      this.props.groupCode.concat('.pdf'),
      false,
      'application/pdf'
    ).then(() => {
      this.setState({
        isExportInProgress: false,
        isShowExportOptions: false,
      });
    }).catch((err) => {
      this._handleExportError(err);
    });
  }

  _getFirstCoveredInClassEntry(coveredInClassContent) {
    if (! coveredInClassContent || ! coveredInClassContent.first) {
      return { unitOrderingSequence: null, lessonNumber: null };
    }

    const firstEntry = coveredInClassContent.first();
    if (! firstEntry) {
      return { unitOrderingSequence: null, lessonNumber: null };
    }

    return {
      unitOrderingSequence: firstEntry.unitOrderingSequence,
      lessonNumber: firstEntry.lessonNumber,
    };
  }

  _renderExportNoSessionsFoundWarningDialog() {
    if (this.state.isNotFoundSessions) {
      return <ConfirmDialog isOpen
          content="No sessions are available for printing."
          primaryButtonContent="OK"
          onPrimaryClick={() =>
          this._onEndExportWarningOrError()} />;
    }
  }

  _renderExportGeneralErrorDialog() {
    if (this.state.isExportErrorOccurred) {
      return <ErrorDialog isOpen
          onConfirmClick={() => {
            this._onEndExportWarningOrError();
          }} />;
    }
  }

  _canCICEdit() {
    const { isNotPublished } = this.props;
    return isNotPublished &&
      this._isNotFutureSession();
  }

  _isNotFutureSession() {
    const { sessionPlans, currentSessionIndex } = this.props;
    const currentSession = sessionPlans.data.get(currentSessionIndex);
    const currentSessionDate = currentSession.period.start;
    return moment().isAfter(currentSessionDate);
  }

  _publishCIC() {
    this.setState({ isChanged: false });
    const {
      params: { sessionPlanId },
      publishCoveredInClass,
      fetchCoveredInClass,
    } = this.props;
    const { coveredInClassContent } = this.props;

    return coveredInClassContent && publishCoveredInClass(
      accessors.filterUncheckItems(coveredInClassContent).toArray(), sessionPlanId)
      .then(() => fetchCoveredInClass(sessionPlanId));
  }

  _clearCIC() {
    this.setState({ isChanged: false });
    const {
      params: { sessionPlanId },
      clearCoveredInClass,
      fetchCoveredInClass,
    } = this.props;

    this._onChangeMode({ mode: '', index: '' });
    return clearCoveredInClass(sessionPlanId)
      .then(() => fetchCoveredInClass(sessionPlanId));
  }

  _renderUnsavedChangesWarningDialog() {
    const { coveredInClassContent, isNotPublished } = this.props;

    if (this.props.isAnyApiCalling) {
      return null;
    }
    if (isNotPublished && accessors.isAllCategoryItemsUnchecked(coveredInClassContent)) {
      return <ConfirmDialog isOpen={!! this._isNavigationWithChangesRequested()}
          primaryButtonContent="Stay"
          secondaryButtonContent="Leave"
          content="Are you sure you want to leave this page and lose unsaved changes?"
          onPrimaryClick={() => {
            this._clearRequestedLocation();
          }}
          onSecondaryClick={() => {
            this.props.resetCoveredInClass(this.props.params.sessionPlanId);
            this._forcePushRequestedLocation();
          }}
          onRequestClose={() => {
            this._clearRequestedLocation();
          }} />;
    }
    return <UnsavedChangesWarning isOpen={
      !! this._isNavigationWithChangesRequested()}
        dialogText="Do you want to publish Covered in Class?"
        primaryButtonLabel="Publish to EF P"
        secondaryButtonContent="Discard"
        isSaving={this.props.isAnyApiCalling}
        onSaveClicked={() => {
          this._publishCIC()
          .then(() => {
            this._forcePushRequestedLocation();
          });
        }}
        onDiscardClicked={() => {
          this.props.resetCoveredInClass(this.props.params.sessionPlanId);
          this._forcePushRequestedLocation();
        }}
        onCloseClicked={() => {
          this._clearRequestedLocation();
        }} />;
  }

  _renderHomeworkSection() {
    const { hf4Homework, coveredInClassContent } = this.props;
    if (! hf4Homework) return null;

    const { unitOrderingSequence, lessonNumber } = this._getFirstCoveredInClassEntry(coveredInClassContent);

    const hasHomeworkContent =
      lessonNumber ||
      hf4Homework.paperHomeworkAssignment ||
      hf4Homework.hasUnitQuiz ||
      hf4Homework.hasMidtermExam ||
      hf4Homework.hasFinalExam;

    if (!hasHomeworkContent) return null;

    const cardTitle = (unitOrderingSequence && lessonNumber)
      ? `Unit ${unitOrderingSequence} Lesson ${lessonNumber}`
      : '';

    const homeworkItems = [
      {
        isVisible: !! lessonNumber,
        label: 'High Flyers APP',
        value: ` Lesson ${lessonNumber}`,
        key: 'homework-hf-app',
      },
      {
        isVisible: !! hf4Homework.paperHomeworkAssignment,
        label: 'Practice Book',
        value: ` ${hf4Homework.paperHomeworkAssignment}`,
        key: 'homework-paper-book',
      },
      {
        isVisible: !! hf4Homework.hasUnitQuiz,
        label: 'Unit Quiz',
        key: 'homework-unit-quiz',
      },
      {
        isVisible: !! (hf4Homework.hasMidtermExam || hf4Homework.hasFinalExam),
        label: 'Assessment',
        key: 'homework-assessment',
      },
    ];

    return <div className={styles.CoveredInClass_homeworkSection}>
      <h2 className={styles.CoveredInClass_homeworkSectionTitle}>Homework</h2>
      <PageCard>
        <PageCard.Heading text={cardTitle} />
        <PageCard.Content>
          {homeworkItems.map((homeworkItem) => (
            homeworkItem.isVisible &&
            <div className={styles.CoveredInClass_homeworkItem} key={homeworkItem.key}>
              <span className={styles.CoveredInClass_homeworkItemLabel}>{homeworkItem.label}</span>
              {homeworkItem.value}
            </div>
          ))}
        </PageCard.Content>
      </PageCard>
    </div>;
  }

  _renderContent() {
    const {
      canEditCoveredInClass,
      changeCoveredInClassObject,
      coveredInClassContent,
      params: { sessionPlanId },
      hasCIC,
      hasCICTemplate,
      isNotPublished,
    } = this.props;

    if (coveredInClassContent && coveredInClassContent.loading) {
      return null;
    }
    // internal notes should be visible in all cases - even when there's no CIC content to show.
    const internalNotesPart = <InternalNotesPart onComponentMounted={(_cmpnt) => {
      this.internalNotesPartComponent = _cmpnt;
    }}
        modeAndIndex={this._getModeAndIndex()}
        onChangeMode={(modeAndIndex) => this._onChangeMode(modeAndIndex)}
        timeZone={this.props.timeZone}
        sessionPlanId={this.props.params.sessionPlanId} />;

    if (! hasCICTemplate && ! hasCIC) {
      return <div>
        {this._renderHomeworkSection()}
        <Grid outerMargin>
          <Grid.Group>
            {internalNotesPart}
            <NoContentMessage text="No new course content was covered." />
          </Grid.Group>
        </Grid>
        {this._renderInClassPerformanceSection()}
      </div>;
    }
    const isEdit = this._canCICEdit() && canEditCoveredInClass;

    return <div>
      {this._renderHomeworkSection()}
      <Grid outerMargin>
      <Grid.Group>
        {(isEdit || ! isNotPublished) &&
          <div className={styles.CoveredInClass_header}>
            {isEdit ?
              <label className={styles.CoveredInClass_header_checkAll}>
                <Checkbox name="check-all"
                    id="check-all"
                    checked={accessors.isAllCategoryItemsChecked(coveredInClassContent)}
                    onChange={() => {
                      this.setState({ isChanged: true });
                      const newCoveredInClassObject =
                      accessors.toggleCategoryItemsCheckedState(coveredInClassContent);
                      changeCoveredInClassObject(newCoveredInClassObject, sessionPlanId);
                    }} />
                <span>Check All</span>
              </label> : <lablel className={styles.CoveredInClass_header_checkAll} />}
              {! isNotPublished && <ColourLabel text="published" colour="green" />}
          </div>}
        {internalNotesPart}
        {this._renderLesson(coveredInClassContent, isEdit)}
      </Grid.Group>
      {this._renderExportOptionDialog()}
      {this._renderExportNoSessionsFoundWarningDialog()}
      {this._renderExportGeneralErrorDialog()}
    </Grid>
    {this._renderInClassPerformanceSection()}
    </div>;
  }

  _renderLesson(coveredInClassObject, isEdit) {
    const { coveredInClassTemplate } = this.props;
    const unchekedTemplate = accessors.toggleCategoryItemsCheckedState(coveredInClassTemplate);
    if (coveredInClassObject) {
      return coveredInClassObject.map((coveredInClass, key) => <div>
        <h2 className={styles.CoveredInClass_homeworkSectionTitle}>Covered in Class</h2>
        <CoveredInClassCategoryView isEdit={isEdit}
            categories={coveredInClass.cicCategories}
            template={unchekedTemplate &&
              unchekedTemplate.get(key) &&
              unchekedTemplate.get(key).cicCategories}
            onCategoriesChanged={
            (newCategories) => this._categoriesChanged(
              newCategories,
              coveredInClass.unitId,
              coveredInClass.lessonNumber)
          } />
        <PageActivitiesPart pageActivities={coveredInClass.cicActivities}
            template={unchekedTemplate &&
                unchekedTemplate.get(key) &&
                unchekedTemplate.get(key).cicActivities}
            isEditMode={isEdit}
            onPageActivitiesChanged={
            (newPageActivities) => this._pageActivitiesChanged(
              newPageActivities,
              coveredInClass.unitId,
              coveredInClass.lessonNumber)
          } />
      </div>);
    }
    return null;
  }

  _renderInClassPerformanceSection() {
    const { groupMembers, cicDisplayLanguage, groupLessonAwards } = this.props;
    if (! groupMembers || groupMembers.size === 0) return null;
    if (! groupLessonAwards) return null;

    const students = groupLessonAwards.students || [];
    const hasAwards = students.some((s) =>
      (s.points && s.points.length > 0) || (s.badges && s.badges.length > 0));

    if (! hasAwards) {
      return <div className={styles.CoveredInClass_homeworkSection}>
        <h2 className={styles.CoveredInClass_homeworkSectionTitle}>In Class Performance</h2>
        <div className={styles.CoveredInClass_performanceCard}>
          <div className={styles.CoveredInClass_performanceHeader}>
            <span>Performance</span>
          </div>
          <div className={styles.CoveredInClass_performanceEmpty}>
            No awards given in this session.
          </div>
        </div>
      </div>;
    }

    const isChineseDisplay = cicDisplayLanguage && cicDisplayLanguage.startsWith('zh');

    // Match API response students with group members by studentId
    const performanceData = students.map((student) => {
      const member = groupMembers.find((m) =>
        m.studentGeneralInfo && m.studentGeneralInfo.id === student.studentId);
      return {
        studentInfo: member ? member.studentGeneralInfo : null,
        points: student.points || [],
        badges: student.badges || [],
      };
    });

    return <div className={styles.CoveredInClass_homeworkSection}>
      <h2 className={styles.CoveredInClass_homeworkSectionTitle}>In Class Performance</h2>
      <div className={styles.CoveredInClass_performanceCard}>
        <div className={styles.CoveredInClass_performanceHeader}>
          <span>Performance</span>
        </div>
        <div className={styles.CoveredInClass_performanceTable}>
          <div className={styles.CoveredInClass_performanceRow + ' ' + styles.CoveredInClass_performanceRowHead}>
            <div className={styles.CoveredInClass_performanceColName}>Name</div>
            <div className={styles.CoveredInClass_performanceColStickers}>Stickers</div>
            <div className={styles.CoveredInClass_performanceColBadges}>Badges</div>
          </div>
          {performanceData.map((studentPerf) => {
            const studentInfo = studentPerf.studentInfo;
            const studentName = studentInfo
              ? `${studentInfo.firstName || ''} ${studentInfo.lastName || ''}`.trim()
              : 'Unknown';
            const avatarUrl = studentInfo && studentInfo.avatarUrl;
            const studentId = studentInfo && studentInfo.id;

            const pointSummary = {
              iconUrl: findPointByUUID(studentPerf.points[0] && studentPerf.points[0].contentUuid),
              amount: studentPerf.points.reduce((sum, it) => sum + it.count, 0),
            };
            const pointIcon = pointSummary.iconUrl && pointSummary.iconUrl.icon;

            return <div className={styles.CoveredInClass_performanceRow} key={studentId}>
              <div className={styles.CoveredInClass_performanceColName}>
                <div className={styles.CoveredInClass_performanceAvatar}>
                  <StudentPicture src={avatarUrl} gender={studentInfo && studentInfo.gender} />
                </div>
                <span>{studentName}</span>
              </div>
              <div className={styles.CoveredInClass_performanceColStickers}>
                {pointIcon && (
                  <div className={styles.CoveredInClass_performanceSticker} data-tooltip="Sticker">
                    <div className={styles.CoveredInClass_performanceStickerContent}>
                      <img src={pointIcon} alt="" className={styles.CoveredInClass_performanceStickerIcon} />
                      <span className={styles.CoveredInClass_performanceStickerCount}>{pointSummary.amount} stickers</span>
                    </div>
                  </div>
                )}
              </div>
              <div className={styles.CoveredInClass_performanceColBadges}>
                {studentPerf.badges.map((badge, idx) => {
                  const badgeInfo = findBadgeByUUID(badge.contentUuid);
                  if (! badgeInfo) return null;
                  const badgeIcon = isChineseDisplay ? badgeInfo.icon_cn : badgeInfo.icon_en;
                  const badgeName = isChineseDisplay ? badgeInfo.name_zh : badgeInfo.name_en;
                  return (
                    <div className={styles.CoveredInClass_performanceBadge} data-tooltip={badgeName} key={idx}>
                      <img src={badgeIcon} alt={badgeName} />
                      {badge.count > 1 && <span className={styles.CoveredInClass_performanceBadgeCount}>x{badge.count}</span>}
                    </div>
                  );
                })}
              </div>
            </div>;
          }).slice(0, this.state.showAllPerformance ? undefined : 2)}
          {!this.state.showAllPerformance && performanceData.length > 2 && (
            <div
              className={styles.CoveredInClass_performanceShowMore}
              onClick={() => this.setState({ showAllPerformance: true })}
            >
              <span>Show more</span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.4425 6.22168L9 9.65668L5.5575 6.22168L4.5 7.27918L9 11.7792L13.5 7.27918L12.4425 6.22168Z" fill="currentColor" />
              </svg>
            </div>
          )}
        </div>
      </div>
    </div>;
  }

  _closeFreeTextPopup() {
    this._onChangeMode({ mode: '', index: '' });
  }

  _addFreeText(CICKey, categoryId, freeText) {
    this.setState({ isChanged: true });
    const { cicCategoryTemplate, params } = this.props;
    let cicKey = CICKey;
    let { coveredInClassContent } = this.props;
    if (! coveredInClassContent) {
      const unitId = params.unitId || 0;
      cicKey = `${unitId}-0`;
      coveredInClassContent = new Map();
      coveredInClassContent = coveredInClassContent.set(`${unitId}-0`, CoveredInClassModel.create({
        cicCategories: [],
        cicActivities: [],
        unitId,
        lessonNumber: 0,
      }));
    }
    let cicCategories = coveredInClassContent.get(cicKey) &&
      coveredInClassContent.get(cicKey).get('cicCategories');

    if (! cicCategories || cicCategories.findIndex((x) => x.get('cicCategoryId') === categoryId) < 0) {
      if (! cicCategories) {
        cicCategories = new List();
      }
      const selectCategory = cicCategoryTemplate.find((x) => x.get('cicCategoryId') === categoryId);
      cicCategories = cicCategories.push(Record({
        cicCategoryId: undefined,
        cicCategoryItems: undefined,
        cicCategoryName: undefined,
      })({
        cicCategoryId: categoryId,
        cicCategoryItems: new List(),
        cicCategoryName: selectCategory.get('cicCategoryName'),
      }));
    }

    cicCategories = cicCategories && cicCategories.update(cicCategories.findIndex((x) => x.get('cicCategoryId') === categoryId),
      (category) => category.update('cicCategoryItems', (cicCategoryItems) => {
        const freeTextIndex = cicCategoryItems.findIndex((item) => item.cicCategoryItemId === 0);
        if (freeTextIndex >= 0) {
          return cicCategoryItems.update(freeTextIndex, (item) =>
            item.update('cicCategoryItemName', (cicCategoryItemName) => `${cicCategoryItemName}\n${freeText}`));
        }
        return cicCategoryItems.push(Record({
          cicCategoryItemId: undefined,
          cicCategoryItemName: undefined,
          isChecked: undefined,
        })({
          cicCategoryItemId: 0,
          cicCategoryItemName: freeText,
          isChecked: true,
        }));
      }
      ));

    let newCoveredInClassContent = new List();
    if (! coveredInClassContent) {
      newCoveredInClassContent = newCoveredInClassContent.push(Record({
        UnitId: undefined,
        cicCategories: undefined,
        cicActivities: undefined,
      })({
        cicCategories,
        cicActivities: new List(),
      }));
    } else {
      newCoveredInClassContent = coveredInClassContent && coveredInClassContent.update(cicKey,
      (cic) => cic.set('cicCategories', cicCategories));
    }

    this.props.changeCoveredInClassObject(newCoveredInClassContent, params.sessionPlanId);
    this._closeFreeTextPopup();
  }

  _renderFreeTextPopup() {
    const { cicCategoryTemplate, coveredInClassContent } = this.props;
    const shouldShowFreeTextPopup = this.props.params.mode &&
      this.props.params.mode === Modes.ADD_FREE_TEXT;
    return shouldShowFreeTextPopup &&
      <AddFreeTextDialog categoryOptions={cicCategoryTemplate}
          onCancel={() => this._closeFreeTextPopup()}
          coveredInClassContent={coveredInClassContent}
          onSave={(cicKey, categoryId, freeText) =>
          this._addFreeText(cicKey, categoryId, freeText)} />;
  }

  render() {
    const { sessionPlans } = this.props;

    if (! sessionPlans || ! sessionPlans.data) {
      return null;
    }

    return <div className={styles.CoveredInClass}>
      {this._renderUnsavedChangesWarningDialog()}
      {this._renderContent()}
      {this._renderFreeTextPopup()}
    </div>;
  }
}

CoveredInClass.getCurrentRouteSegment = (props) =>
  props.routes[props.routes.length - 1];

CoveredInClass.propTypes = {
  children: PropTypes.node,
  timeZone: PropTypes.string,
  groupName: PropTypes.string,
  groupCode: PropTypes.string,
  languageCode: PropTypes.string,
  cicDisplayLanguage: PropTypes.string,
  sessionPlans: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  pushRoute: PropTypes.func.isRequired,
  currentSessionIndex: PropTypes.number,
  fetchSessionPlansIfNeeded: PropTypes.func,
  state: PropTypes.object.isRequired,
  router: PropTypes.any.isRequired,
  route: PropTypes.any.isRequired,
  routes: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  buildRoute: PropTypes.func.isRequired,
  fetchCoveredInClassIfNeeded: PropTypes.func.isRequired,
  fetchCoveredInClassTemplateIfNeeded: PropTypes.func.isRequired,
  fetchHFv4CICTemplateIfNeeded: PropTypes.func.isRequired,
  fetchHFv4CICTemplate: PropTypes.func,
  coveredInClassObject: PropTypes.object,
  fetchCoveredInClass: PropTypes.func,
  changeCoveredInClassObject: PropTypes.func,
  publishCoveredInClass: PropTypes.func,
  clearCoveredInClass: PropTypes.func,
  canEditCoveredInClass: PropTypes.bool.isRequired,
  sessions: PropTypes.object,
  currentSessionId: PropTypes.string.isRequired,
  showNavigationBar: PropTypes.bool.isRequired,
  isAnyApiCalling: PropTypes.bool,
  isNotPublished: PropTypes.bool,
  hasCICTemplate: PropTypes.bool.isRequired,
  cicCategoryTemplate: PropTypes.object,
  fetchCICCategoriesIfNeeded: PropTypes.func,
  hf4Homework: PropTypes.object,
  fetchHF4HomeworkIfNeeded: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
  const { groupId, sessionPlanId } = ownProps.params;
  const group = state.get('rootReducer').get('groups').get(groupId).data;
  const { timeZone } = Group.getCentre(state, group.id);
  const languageCode = group.get('languageCode');
  const groupName = group.name;
  const groupCode = group.number;

  const { sessionPlans: sessionPlanIds } = group;
  if (is.undefined(sessionPlanIds.data)) {
    return { timeZone, groupName, sessionPlans: sessionPlanIds };
  }
  const isNotPublished = accessors.isNotPublished(state, ownProps.params);
  const hasCICTemplate = accessors.hasCICTemplate(state, ownProps.params);
  const hasCIC = accessors.hasCIC(state, ownProps.params);
  const sessionPlansInfo =
    state.get('rootReducer').get('sessionPlans').filter((session) => session.groupId === group.id);
  const units = getUnitList(state, groupId);
  const currentSessionPlanId = sessionPlanId;
  const sessionPlans = sessionPlanIds.update('data', (data) => new List(data))
    .update('data', (data) =>
      data.map((planId) => sessionPlansInfo.get(planId)));
  const currentSessionIndex = sessionPlans.data.findIndex((plan) =>
    plan.id === currentSessionPlanId
  );

  const cicCategoryTemplate = state
    .get('rootReducer')
    .get('cicCategoryTemplate')
    .get(groupId);

  const canEditCoveredInClass =
    ! Group.isAutoPublishCIC(state, groupId) &&
    ! Group.isHFV4CourseTypeGroup(state, groupId) &&
      PrivilegeChecker.hasPrivilege(state, Privileges.CoveredInClass.MarkAndPublish);

  let coveredInClassContent = state
    .get('rootReducer')
    .get('coveredInClassContent')
    .get(currentSessionPlanId);

  let coveredInClassTemplate = state
    .get('rootReducer')
    .get('coveredInClassTemplate')
    .get(currentSessionPlanId);
  coveredInClassTemplate = hasCICTemplate &&
    coveredInClassTemplate.map((CIC) =>
      CIC.set('unitOrderingSequence', getUnitNumberById(units, `${CIC.unitId}`)))
      .sort(sortCoverdInClass);

  if (hasCIC || ! isNotPublished) {
    coveredInClassContent = coveredInClassContent.map((CIC) =>
      CIC.set('unitOrderingSequence', getUnitNumberById(units, `${CIC.unitId}`)))
      .sort(sortCoverdInClass);
  } else {
    coveredInClassContent = coveredInClassTemplate;
  }

  const showNavigationBar = UiState.getShowNavigationBar(state);
  const cicDisplayLanguage = Group.isIDGroup(state, groupId)
    ? Languages.defaultLanguageCode
    : (UiState.getCICDisplayLanguage(state) || Languages.defaultLanguageCode);
  const hf4Homework = hf4HomeworkAccessors.getHF4Homework(state, currentSessionPlanId);
  const groupMembers = getMembersByGroup(state, groupId);

  const groupLessonAwards = groupLessonAwardsAccessors.getGroupLessonAwards(state, currentSessionPlanId);

  return {
    state,
    timeZone,
    groupName,
    groupCode,
    languageCode,
    cicDisplayLanguage,
    sessionPlans,
    currentSessionIndex,
    coveredInClassContent,
    coveredInClassTemplate,
    canEditCoveredInClass,
    sessions: sessionPlansInfo,
    isNotPublished,
    hasCICTemplate,
    hasCIC,
    currentSessionId: currentSessionPlanId,
    showNavigationBar,
    isAnyApiCalling: !! isAnyApiCalling(state),
    cicCategoryTemplate,
    hf4Homework,
    groupMembers,
    groupLessonAwards,
  };
}

function sortCoverdInClass(a, b) {
  if (a.unitOrderingSequence !== b.unitOrderingSequence) {
    return a.unitOrderingSequence - b.unitOrderingSequence;
  }
  return a.lessonNumber - b.lessonNumber;
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    { pushRoute: (path) => dispatch(push(path)) },
    bindActionCreators(sessionPlansActions, dispatch),
    bindActionCreators(CoveredInClassActions, dispatch),
    bindActionCreators(CoveredInClassTemplateActions, dispatch),
    bindActionCreators(CICCategoryTemplateActions, dispatch),
    bindActionCreators(HF4HomeworkActions, dispatch),
    { fetchGroupMembersIfNeeded: (groupId) => dispatch(fetchGroupMembersIfNeeded(groupId)) },
    { fetchGroupLessonAwardsIfNeeded: (sessionId) =>
      dispatch(fetchGroupLessonAwardsIfNeeded(sessionId)) },
  );
}

function isAnyApiCalling(state) {
  return !! (state.get('apiCalls') || new List())
    .filter((call, key) =>
      ['PUT', 'POST', 'GET'].some((method) => key.startsWith(method)))
    .find((call) => ApiCall.State.isLoading(call));
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CoveredInClass));



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClassHFv4/component.jsx